import { useEffect, useState } from "react"

import {
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Card,
    CardBody,
    CardHeader,
    Collapse,
} from "reactstrap"

import classnames from "classnames"

import { MDB_TYPES as TYPES, HEADING } from "@meddbriefer/scenario-data/constants.js"

// import { usePrefs }    from "../contexts/PreferencesContext"
import { useScenario } from "../contexts/ScenarioContext"

import ChevronIcon from "./icons/ChevronIcon"

import Panel from "./Panel"

const InterventionOutline = ({ category }) => {

    const { scenario, setCurrIntv, setShowIntvSelection } = useScenario()
    const [intvCatMenu, setIntvCatMenu] = useState(null)

    const handleInterventionSelection = (event, item) => {
        setShowIntvSelection(false)
        setTimeout(() => setCurrIntv(item.interventionID), 500)
    }

    useEffect(() => {
            const menu = scenario.interventionMenus.find(im => im.id === category)
            if (menu) {
                setIntvCatMenu(menu)
                setCurrIntv(null)
            } else {
                setIntvCatMenu(null)
                setCurrIntv(null)
            }
        }, [category, scenario.interventionMenus, setCurrIntv]
    )


    return (
        <ul className="interventions-outline">
            {!!intvCatMenu && intvCatMenu.items.map(item => (
                <li
                    key={`${item.id}-${item.depth}`}
                    className={classnames([`menu-depth-${item.depth}`, (item.type === HEADING) ? "menu-heading" : "intervention"])}
                >
                    {item.type === TYPES.INTERV
                        ? <Button
                            color="link"
                            size="md"
                            className="intervention-btn"
                            onClick={(event) => handleInterventionSelection(event, item)}
                        >
                            {item.label}
                        </Button>
                        : <span>{item.label}</span>
                    }
                </li>
            ))}
        </ul>
    )
}

const InterventionsAccordian = () => {
    const { scenario, currIntvCat, setCurrIntvCat } = useScenario()
    const toggleCat = (menuID) => {
        if (currIntvCat === menuID) {
            setCurrIntvCat("")
        } else {
            setCurrIntvCat(menuID)
        }
    }

    return (
        <div>
            <ShowCurrentBreadcrumb/>
            {scenario.interventionMenus.map(menu => (
                <Card key={menu.id}>
                    <CardHeader
                        className="intervention-submenu"
                        onClick={() => toggleCat(menu.id)}
                    >
                        {menu.label} <ChevronIcon expand={menu.id === currIntvCat} />
                    </CardHeader>
                    <Collapse isOpen={currIntvCat === menu.id}>
                        <CardBody className="intervention-outline-wrapper">
                            <InterventionOutline category={menu.id} />
                        </CardBody>
                    </Collapse>
                </Card>
            ))
            }
       </div>
        
    )
}

function ShowCurrentBreadcrumb () {
    const { setCurrIntvCat, currIntvCat, scenario } = useScenario()
    const menu = scenario.interventionMenus.find(im => im.id === currIntvCat)

    const toggleCat = (menuID) => {
        if (currIntvCat === menuID) {
            setCurrIntvCat("")
        } else {
            setCurrIntvCat(menuID)
        }
    }
    if (menu){
        return (
            <Breadcrumb>
            <BreadcrumbItem onClick={() => toggleCat(menu.id)}> Interventions</BreadcrumbItem>
            <BreadcrumbItem active>{menu.label}</BreadcrumbItem>
            </Breadcrumb>   
            )}
           
    }
      



export default function InterventionsList() {
    const { showIntvSelection, setShowIntvSelection, setCurrIntv } = useScenario()

    const toggleCollapsed = () => {
        if (!showIntvSelection) {
            setCurrIntv(null)
        }
        setShowIntvSelection(!showIntvSelection)
    }


    return (
        <Panel
            title="Interventions"
            collapsable={true}
            customCollapsedState={!showIntvSelection}
            customCollapseToggler={toggleCollapsed}
        >
            <InterventionsAccordian />
        </Panel>
    )

}
